import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { StarPicker } from "./Stars";
import axios, { API, deviceId, errMsg } from "../lib/api";

export const ReviewDialog = ({ washer, open, onOpenChange, onDone }) => {
  const [rating, setRating] = useState(0);
  const [author, setAuthor] = useState("");
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!rating) return toast.error("Alege o notă de la 1 la 5 stele.");
    setBusy(true);
    try {
      await axios.post(`${API}/washers/${washer.id}/reviews`, { rating, author, comment, device_id: deviceId() });
      toast.success("Mulțumim! Recenzia a fost trimisă.");
      setRating(0); setAuthor(""); setComment("");
      onOpenChange(false);
      onDone?.();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md border-white/10 bg-[#131B26]" data-testid="review-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Cum a fost spălarea?</DialogTitle>
          <DialogDescription>Recenzie pentru <b className="text-white">{washer?.name}</b></DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-5">
          <StarPicker value={rating} onChange={setRating} />
          <div className="space-y-1.5">
            <label className="text-xs uppercase tracking-[0.2em] text-slate-400">Numele tău (opțional)</label>
            <Input data-testid="review-author-input" value={author} maxLength={60}
              onChange={(e) => setAuthor(e.target.value)} placeholder="ex. Andrei" />
          </div>
          <div className="space-y-1.5">
            <label className="text-xs uppercase tracking-[0.2em] text-slate-400">Comentariu</label>
            <Textarea data-testid="review-comment-textarea" value={comment} maxLength={1000} rows={4}
              onChange={(e) => setComment(e.target.value)} placeholder="Spune-ne pe scurt cum a fost..." />
          </div>
          <button type="submit" disabled={busy} data-testid="submit-review-btn"
            className="flex w-full items-center justify-center gap-2 rounded-full bg-[#00F0FF] py-3.5 font-semibold text-[#090E17] transition-colors hover:bg-[#33F3FF] disabled:opacity-60">
            {busy && <Loader2 className="animate-spin" size={18} />} Trimite recenzia
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
